/**
 *
 * @ webuser-object to encapsulate
 *   webuser-functions
 * @ Author: olbe, 13.04.2015
 *
 */
var oWebUser =
    {
        // download report-files
        startDownload: function (sid, sortBy, filter, location, usertypefilter) {
            var postData = {};

            // data, which are not changeable by user
            postData.sid = sid;
            postData.action = "list";
            postData.sortby = sortBy;
            postData.filter_user = filter;
            postData.listaction = "usermanager";
            postData.filter_location = location;
            postData.filter_type = usertypefilter;

            // data, who can be changed by user before starting report
            postData.approver_flag = $("[name='approver_flag']").val();
            postData.auto_generate_flag = $("[name='auto_generate_flag']").val();

            // generate download
            oDownload.generate(
                "downloadXLS.phtml",
                postData,
                "POST"
            );
        }
    };

/**
 *
 * @ positonreport-object to encapsulate
 *   postionreport-functions
 * @ Author: joga, 07.09.2015
 *
 */
var oPositionreport =
    {
        // download positionreport-file
        startDownload: function (sid, sortBy, startDate, endDate) {
            var postData = {};

            // data, which are not changeable by user
            postData.sid = sid;
            postData.action = "positionreport_new";
            postData.sortby = sortBy;
            postData.startdate = startDate;
            postData.enddate = endDate;
            postData.listaction = "positionreport_new";

            // generate download
            oDownload.generate(
                "downloadXLS.phtml",
                postData,
                "POST"
            );
        }
    };


/**
 *
 * @ simple quick-download-object
 * @ Author: olbe, 13.04.2015
 *
 */
var oDownload =
    {
        iObjCount: 0,
        // generates and exports user-data
        generate: function (url, data, method) {


            notification.info('preparing download... ' + output['t_bitte_warten']);
            // prepare parameters
            var request_data = (typeof data === "string" ? data : $.param(data));

            // do the download-request
            oDownload.iObjCount++;
            var iDownloader = $("<iframe id='fr_" + oDownload.iObjCount + "' style='visibility:hidden;display:none;'/>");
            iDownloader.load(function () {
                if (iDownloader.contents().find("body").html().toUpperCase() === "FAIL") {
                    classicErrrorMessage(output['t_keine_daten_vorhanden']);
                }
            })
                .appendTo("body")
                .attr({src: url + "?" + request_data});
        },
        // downloads cartarticle-file
        attachment: function (sid, caid) {


            // do the download-request
            $("<iframe />").attr({
                src: './cartarticle_getfile.phtml?sid=' + sid + '&caid=' + caid,
                style: "display:none;visibility:hidden;"
            }).appendTo('body');
            return false;
        }
    };

/**
 *
 * @ simple quick-upload-object
 * @ Author: olbe, 08.06.2015
 *
 */
var oUpload =
    {
        formData: {},
        fileTypes: '',
        initFunc: null,
        // initializes the data-obj
        init: function () {
            oUpload.formData = {};
            oUpload.formData.sid = '';
            oUpload.formData.parameter = {};

            if (typeof (oUpload.initFunc) === 'function') {
                oUpload.initFunc();
            }
        },
        // uploads given file(s)
        start: function (event) {
            event.stopPropagation();
            event.preventDefault();

            var files = event.target.files;
            for (var i = 0, file; file = files[i]; i++) {
                var fileName = file.name;
                var fileExt = '.' + fileName.toLowerCase().split('.').pop();
                if (oUpload.fileTypes.toLowerCase().indexOf(fileExt) === -1) {
                    classicErrrorMessage(output['t_wrong_filetype']);
                    $('.appMessage').css('color', 'red');
                    return false;
                }
            }

            $(document).keyup(function (e) {
                if (e.which === 27) {
                    $('#uploadOverlay').remove();
                }
            });

            $.ajax({
                url: mainURL + 'ajax/Public/UploadFile/toFolder',
                type: 'POST',
                xhr: function () {
                    var myXhr = $.ajaxSettings.xhr();
                    return myXhr;
                },
                success: function (responseData, textStatus, jqXHR) {
                    response = JSON.parse(responseData);

                    if (response.result === 'DONE') {
                        setTimeout(function () {
                            $('#uploadOverlay').remove();
                        }, 1000);
                        classicErrrorMessage("<font class='appMessage'>&nbsp;" + output['t_dateiupload_erfolgreich'] + "&nbsp;</font>");
                        $('.appMessage').css('color', 'green');
                    } else {
                        setTimeout(function () {
                            $('#uploadOverlay').remove();
                        }, 1000);
                        classicErrrorMessage("<font class='appMessage'>&nbsp;" + output['t_fehler_beim_dateiupload'] + "&nbsp;</font>");
                        $('.appMessage').css('color', 'red');
                    }

                    oUpload.init();
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    setTimeout(function () {
                        $('#uploadOverlay').remove();
                    }, 1000);
                    classicErrrorMessage("<font class='appMessage'>&nbsp;" + output['t_fehler_beim_dateiupload'] + "&nbsp;</font>");
                    $('.appMessage').css('color', 'red');

                    oUpload.init();
                },
                data: oUpload.formData,
                cache: false,
                contentType: false,
                processData: false
            });
        }
    };
